/**
 * Runs a read, resolving a 404 to `fallback` instead of throwing.
 *
 * Three reads in this domain treat "not found" as an answer rather than a
 * failure — an unknown cycle id, a member who never applied, a member nobody
 * has reviewed — and each of them used to spell the same try/catch out again.
 * The rule now lives in one place; *why* a 404 is an ordinary answer differs
 * per read, so that reasoning stays at each call site.
 *
 * Only 404 is caught. A 403 or a 500 propagates, so a permissions or server
 * failure can never masquerade as an absence.
 */
export const withNotFoundAs = async (fallback, read) => {
  try {
    return await read();
  } catch (error) {
    if (error?.response?.status === 404) return fallback;

    throw error;
  }
};
